/*
  specifically added to be able to enter emails with " symbol
  and add required domain
 */
export const CUSTOM_EMAIL = /^[a-zA-Z0-9".!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;